module.exports = __webpack_public_path__ + "static/img/zhuapaijilu2.2cd0037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zhuapaijilu2.png
// module id = /hp4
// module chunks = 24